module.exports = __webpack_public_path__ + "img/lunbo2.85b0e096.jpg";